import BaseEvent from './BaseEvent.js';

class SessionTerminationEvent extends BaseEvent {
  handle() {
    this.context._eyeson.destroy();
  }
}

export default SessionTerminationEvent;
